module.exports = __webpack_public_path__ + "static/media/michael1.5743b77b.jpg";